import http from './http'

class Funds {
  fetch () {
    return http.get('/funds_by_list')
  }

  get (id) {
    return http.get(`/funds/${id}`)
  }

  save (payload) {
    return http.post('/funds', { fund: payload })
  }

  update (payload) {
    return http.put(`/funds/${payload.id}`, { fund: payload })
  }
}

export default new Funds()



// WEBPACK FOOTER //
// ./src/services/funds.js